import { useEmergencyBannerQuery } from 'generated/sanity-graphql';

export const useEmergencyBanner = (id?: string) => {
  const emergencyBannerId = id ?? '';
  const { data, loading } = useEmergencyBannerQuery({
    variables: {
      emergencyBannerId,
    },
    skip: !emergencyBannerId,
  });

  const emergencyBanner = data?.EmergencyBanner;

  return {
    emergencyBanner,
    emergencyBannerLoading: loading,
  };
};
